<template>
    <generic-page>
        <b-btn variant="link" size="lg" class="pl-0" to="/account">
            <font-awesome-icon size="lg" icon="fa-light fa-chevron-left" />
            {{ $t("Account") }}
        </b-btn>

        <h5>
            {{ $t("Network") }}
        </h5>

        <b-list-group>
            <b-list-group-item :key="brand.id" v-for="brand in brands">
                <div class="d-flex align-items-center justify-content-between">
                    <div>
                        <img
                            class="rounded small-avatar"
                            :src="brand.logo100"
                        />
                        {{ brand.name }}
                    </div>
                    <div>
                        <b-badge v-if="brand.current" variant="primary" pill>
                            {{ $t("Current Network") }}
                        </b-badge>
                    </div>
                </div>
                <div class="small mt-2">
                    {{ brand.description }}
                </div>
                <div v-if="!brand.current" class="mt-3">
                    <b-btn
                        @click="changeBrand(brand)"
                        variant="primary"
                        block
                        pill
                    >
                        Change to this network
                    </b-btn>
                </div>
            </b-list-group-item>
        </b-list-group>

        <b-alert variant="primary" show class="mt-3 small">
            <font-awesome-icon icon="fa-duotone fa-info-circle" />
            {{
                $t(
                    "Changing your network will not affect any of your existing conversations, and will only change your user discovery filters for finding new users"
                )
            }}
        </b-alert>
    </generic-page>
</template>



<script>
export default {
    data() {
        return {
            brands: null,
        };
    },
    mounted() {
        this.refresh();
    },
    methods: {
        changeBrand(brand) {
            this.api.post(`/brand/${brand.id}/change`).then(() => {
                this.refresh();

                this.$store.dispatch("user/refreshFilteredContent");
            });
        },
        refresh() {
            this.api.post("/brand/index").then((response) => {
                this.brands = response.data.brands;
            });
        },
    },
    components: {},
};
</script>